import React, {useEffect} from 'react';
import type {MenuProps} from 'antd';
import {Button, Dropdown, Image, Switch, Tooltip} from "antd";
import _, {isNumber} from "lodash";
import {StyledButton} from "../../../widgets/IconButtonWidget/component";
import styled from "styled-components";
import dayjs from "dayjs";
import IconPark from '@icon-park/react/es/all';
import ResizeTable from './ResizeTable';
import tinycolor from "tinycolor2";
import {apiPath} from "@byk/routes";
import {getTenant} from "../../../utils/localStorage";
import {formatNumber, hexToRgb, isURL} from "@byk/utils/Utils";
import {lightenColor, useWidgetPermission} from "../../../widgets/WidgetUtils";
import {FontStyleTypes} from "../../../constants/WidgetConstants";
import { fileCodeToPath, isValidJSON } from "../../../utils/XUtils";
import {ColumnTypes} from "../widget/propertyConfig/PanelConfig/General";
import {getIconPark} from "../../../components/propertyControls/IconSelectControl";
import {getEvalValue} from "../../../workers/Evaluation/evaluateUtil";

const StyledTable = styled((props: any) => (<ResizeTable {...props} />))`
  /* 表格操作栏固定时错位，注释后正常
  .ant-table-body,
  .ant-table-body-inner {
    &::-webkit-scrollbar {
      width: 0;
    }
  }

  .ant-table-cell-fix-right{
    right:0px !important;
  }

  table{
    border: none!important;
  }
  table, th, td,.ant-table-container{
    border: none!important;
  }
  .ant-table-body{
    overflow-x: auto !important;
  }
  .ant-table-cell-scrollbar{
    box-shadow: none!important;
    width:0px !important;
    border-left:0px !important;
    display:none;
  }*/

  .ant-table-body{
    min-height: ${({height}) => height} !important;
  }
  .ant-table-selection-column .ant-checkbox-wrapper{
    display:flex;
    justify-content: center;
  }

  ${({isTree, primaryColorTheme}) => `
    .ant-table-row-expand-icon {
       display: ${isTree ? 'inline-flex' : 'none'} !important;
    }

    ${isTree? `
      .ant-table-row-expand-icon:focus, .ant-table-row-expand-icon:hover, .ant-table-row-expand-icon:active {
        border-color: ${primaryColorTheme};
      }
      .ant-table-row-expand-icon:focus-visible, .ant-table-row-expand-icon:hover {
        color: ${primaryColorTheme};;
      }
    ` : ``}
  `}


  ${({boxShadow}) => `
    .ant-table-container{
      box-shadow: ${boxShadow}
    }
  `}
  ${({borderRadius}) => `
    .ant-table-container{
      border-radius: ${borderRadius}!important;
    }
    .ant-table{
      border-radius: ${borderRadius}!important;
    }
  `}

  ${({variant, borderColor, borderWidth}) => `
    ${variant === "DEFAULT" || !variant ? `
      .ant-table-container{
        border: ${borderWidth ?? 1}px solid ${borderColor || '#f0f0f0'}!important;
      }
      .ant-table-header .ant-table-cell{
        border-left: ${borderWidth ?? 1}px solid ${borderColor || '#f0f0f0'}!important;
        border-bottom: ${borderWidth ?? 1}px solid ${borderColor || '#f0f0f0'}!important;
      }
      .ant-table-header .ant-table-cell:first-child{
        border-left: none!important;
      }
      .ant-table-tbody .ant-table-row .ant-table-cell{
        border-left: ${borderWidth ?? 1}px solid ${borderColor || '#f0f0f0'}!important;
        border-bottom: ${borderWidth ?? 1}px solid ${borderColor || '#f0f0f0'}!important;
      }
      .ant-table-tbody .ant-table-row:last-child .ant-table-cell{
        border-bottom: none!important;
      }
      .ant-table-tbody .ant-table-row .ant-table-cell:first-child{
        border-left: none!important;
      }
    ` : ``}
  `}
  ${({variant, borderColor, borderWidth}) => `
    ${variant === "VARIANT3" ? `
      .ant-table-thead .ant-table-cell,.ant-table-tbody .ant-table-row .ant-table-cell{
        border-bottom: ${borderWidth ?? 1}px solid ${borderColor || '#f0f0f0'}!important;
      }
    ` : ``}
  `}

  .ant-table-thead>tr>th {
    background: ${({backgroundHead}) => backgroundHead||"#fafafa"}!important;
  }

  th {
    font-size: ${({textSizeHead}) => textSizeHead}!important;
    color:${({textColorHead}) => textColorHead}!important;
    font-weight:${({fontStyleHead}) => fontStyleHead && fontStyleHead.indexOf('bold')>=0?'bold':'normal'}!important;
    font-style:${({fontStyleHead}) => fontStyleHead && fontStyleHead.indexOf('italic')>=0?'italic':'normal'}!important;
    vertical-align:${({verticalAlignmentHead}) => verticalAlignmentHead}!important;
  }

  .thAlignLeft {
    text-align: left !important;
  }

  .thAlignCenter {
    text-align: center !important;
  }

  .thAlignRight {
    text-align: right !important;
  }

  td {
    font-size: ${({textSizeBody}) => textSizeBody}!important;
    color:${({textColorBody}) => textColorBody}!important;
    font-weight:${({fontStyleBody}) => fontStyleBody && fontStyleBody.indexOf('bold')>=0?'bold':'normal'}!important;
    font-style:${({fontStyleBody}) => fontStyleBody && fontStyleBody.indexOf('italic')>=0?'italic':'normal'}!important;
    text-align:${({horizontalAlignmentBody}) => horizontalAlignmentBody}!important;
    vertical-align:${({verticalAlignmentBody}) => verticalAlignmentBody}!important;
  }

  .ant-table-body tr:hover td {
    background:${({backgroundMouseOver}) => backgroundMouseOver} !important;
  }

  ${({isZebraStripe, backgroundBody1, backgroundBody2, backgroundMouseOver}) => `
    ${`
    .ant-table-body tr:nth-child(odd) {
      background: ${backgroundBody1};
    }
    .ant-table-body tr:nth-child(even) {
      background: ${isZebraStripe ? backgroundBody2 : backgroundBody1};
    }
    `}
  `}

  .ant-pagination {
    padding-right: 8px;

    .ant-pagination-item-active {
      border-color:${({primaryColorTheme}) => primaryColorTheme} !important;
    }

    .ant-pagination-item-active a {
      color:${({primaryColorTheme}) => primaryColorTheme} !important;
    }

    .ant-pagination-item-link {
      color:${({primaryColorTheme}) => primaryColorTheme} !important;
    }

    .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {
      background: ${({primaryColorTheme}) => hexToRgb(primaryColorTheme, 0.15)};
    }

    .ant-select:not(.ant-select-disabled):hover .ant-select-selector {
      border-color: ${({primaryColorTheme}) => primaryColorTheme} !important;
    }

    .ant-select-focused:not(.ant-select-disabled).ant-select:not(.ant-select-customize-input) .ant-select-selector {
      border-color: ${({primaryColorTheme}) => primaryColorTheme} !important;
      box-shadow: 0 0 0 2px ${({primaryColorTheme}) => lightenColor(primaryColorTheme)} !important;
    }
  }

  .ant-image,.ant-image-img{
    display: block;
  }

  .ant-radio-checked .ant-radio-inner,
  .ant-radio-wrapper:hover .ant-radio, .ant-radio:hover .ant-radio-inner, .ant-radio-input:focus + .ant-radio-inner {
    border-color: ${({primaryColorTheme}) => primaryColorTheme} !important;
  }

  .ant-radio-inner::after {
    background-color: ${({primaryColorTheme}) => primaryColorTheme} !important;
  }

  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: ${({primaryColorTheme}) => primaryColorTheme} !important;
    border-color: ${({primaryColorTheme}) => primaryColorTheme} !important;
  }

  .ant-checkbox-wrapper:hover .ant-checkbox-inner, .ant-checkbox:hover .ant-checkbox-inner, .ant-checkbox-input:focus + .ant-checkbox-inner {
    border-color: ${({primaryColorTheme}) => primaryColorTheme} !important;
  }

  .ant-checkbox-indeterminate .ant-checkbox-inner::after {
    background-color:  ${({primaryColorTheme}) => primaryColorTheme} !important;
  }
`

export const ButtonWrapper = styled.div<{
  borderRadiusBtn: string,
  boxShadowBtn: string,
  btnTextAlign?: string,
  backgroundBtn: string,
  btnFontSize: any,
  btnFontColor: any,
  btnFontStyle: any,
  iconRight?:any,
  iconLeft?:any,
}>`
  display: inline-block;
  vertical-align: middle;
  margin-top: 10px;

  .ant-btn {
    display: flex;
    align-items: center;
    border-radius: ${({borderRadiusBtn}) => borderRadiusBtn} !important;
    box-shadow: ${({boxShadowBtn}) => boxShadowBtn} !important;
    color: ${({btnFontColor}) => btnFontColor} !important;
    font-size: ${({btnFontSize}) => btnFontSize || '0.875rem'} !important;
    height: inherit !important;
    min-height: 32px !important;
    font-style: ${({btnFontStyle}) => {
      return (btnFontStyle?.includes(FontStyleTypes.ITALIC) ? "italic" : "") + ' !important;'
    }};
    font-weight: ${({btnFontStyle}) => {
      return (btnFontStyle?.includes(FontStyleTypes.BOLD) ? "bold" : "") + ' !important;'
    }};
    .i-icon {
      ${({iconLeft}) => iconLeft ? 'margin-right:5px  !important;' : ''}
      ${({iconRight}) => iconRight ? 'margin-left:5px  !important;' : ''}
    }
  }

  .ant-btn[disabled], .ant-btn[disabled]:active, .ant-btn[disabled]:focus, .ant-btn[disabled]:hover {
    color: rgba(0,0,0,.25) !important;
    border: none !important;
    background: #f5f5f5 !important;
    text-shadow: none !important;
    box-shadow: none !important;
  }

  .ant-btn-default {
    border-color: ${({backgroundBtn}) => backgroundBtn} !important;
    &:hover{
      color: ${({btnFontColor}) => btnFontColor} !important;
      border-color: ${({backgroundBtn}) => backgroundBtn} !important;
      background: ${({backgroundBtn}) => backgroundBtn ? tinycolor(backgroundBtn).setAlpha(0.1).toRgbString() : ''};
    }
  }
  .ant-btn-primary{
    background: ${({backgroundBtn}) => backgroundBtn}!important;
    border: none!important;
    &:hover{
      opacity: .8;
    }
  }
  .ant-btn-text{
    border: none !important;
    &:hover{
      color: ${({btnFontColor}) => btnFontColor}!important;
      background: ${({backgroundBtn}) => tinycolor(backgroundBtn).setAlpha(0.1).toRgbString()};
    }
  }

  .ant-btn-secondary {
    border-color: ${({backgroundBtn}) => backgroundBtn} !important;
    &:hover{
      color: ${({btnFontColor}) => tinycolor(btnFontColor).setAlpha(0.85).toRgbString()} !important;
      background: ${({backgroundBtn}) => tinycolor(backgroundBtn).setAlpha(0.1).toRgbString()};
    }
  }

  .ant-btn-two-chinese-chars>:not(.anticon) {
    margin-right: 0!important;
    letter-spacing: 0!important;
  }
`;

export function ActionMenu(props: any) {
  const items = props.items as MenuProps['items'];
  return (
    <Dropdown menu={{items}}>
      {props.children}
    </Dropdown>
  )
}

export const SwitchWrapper = styled<any>(Switch)`
  &.ant-switch-checked {
    background-color: ${({color}) => color}!important;
  }
`

//是否显示操作列
export const reIsVisible = (props:any, data: any, index: number) => {
  // const {widgetName, tableData} = props;
  if (_.isBoolean(data)) {
    return data;
  } else if (_.isArray(data)) {
    return data[index];
    // 和xzy讨论分析后，这个代码场景没有，以前遗留下来的代码
  // } else if (!_.isEmpty(tableData)&&_.isString(data) && data.startsWith("{{") && data.endsWith("}}")) {
  //   const ddd = data.replace(`${widgetName}.allData`, "xData").replace("{{", "").replace("}}", "");
  //   const xData = _.cloneDeep(tableData);//不能删
  //   const visibleArr = eval(ddd);
  //   return visibleArr[index];
  }
  return data;
}

export const reItems = (props:any, i: any, record: any, index: number) => {
  let style = getColumnStyleCfg(props, i, record, index);
  let isVis = reIsVisible(props, i.isCellVisible, index);
  let isDis = reIsVisible(props, i.isCellDisable, index);

  // 7101 【SIT】权限设置中，给table的某一列（如下图给设备类型）取消勾选，预览时，table中依然有设备类型列
  // 7100 【SIT】权限设置中，给table的“编辑”按钮或者整个操作列都取消勾选，保存后预览时，table中依然显示了“编辑”按钮
  if (props.widgetVisible) {
    isVis = isVis && props.widgetVisible.includes(`${props.widgetId}_ACTION_${i.id}`);
  }

  let backgroundBtn = style.backgroundBtn;
  let btnFontColor = style.fontColor;
  if (!backgroundBtn) {
    backgroundBtn = props.accentColor;
  }
  if (!btnFontColor) {
    btnFontColor = props.accentColor;
  }

  if (backgroundBtn == "{{appsmith.theme.colors.primaryColor}}") {
    backgroundBtn = props.primaryColor;
  } else  if (backgroundBtn == "{{appsmith.theme.colors.backgroundColor}}") {
    backgroundBtn = props.backgroundColor;
  }

  if (_.isNumber(style.borderRadiusBtn)) {
    style.borderRadiusBtn += 'px';
  }

  return (
    <ButtonWrapper
      borderRadiusBtn={style.borderRadiusBtn}
      backgroundBtn={backgroundBtn}
      boxShadowBtn={style.boxShadowBtn}
      btnTextAlign={style.btnTextAlign}
      btnFontSize={style.fontSize}
      btnFontStyle={style.fontStyle}
      btnFontColor={btnFontColor}
    >
      <Button size={`middle`} className={`x-table-btn`} disabled={isDis}
              onClick={() => {
                if (props.onCellClick) {
                  if (i.btnOnClick) {
                    props.onCellClick(record, i.onClick, i.btnOnClick);
                  } else {
                    props.onCellClick(record, i.onClick)
                  }
                }
              }}
              type={style.btnType}
              style={{minWidth: '64px', margin: '0 5px 1px 0', display: isVis ? 'inline-block' : 'none'}}>
        <div style={{display: 'flex', alignItems: 'center', justifyContent: `${style.btnTextAlign || 'center'}`}}>
          {
            (style.btnIcon && style.btnIcon != 'none' && style.btnPosition != 'right') && <IconPark type={style.btnIcon} fill={style.iconColor}/>
          }
          <div>{i.btnLabel || i.label}</div>
          {
            (style.btnIcon && style.btnIcon != 'none' && style.btnPosition == 'right') && <IconPark type={style.btnIcon} fill={style.iconColor}/>
          }
        </div>
      </Button>
    </ButtonWrapper>
  );
}

/*
  树状结构的table，根据record找到对应的索引
 */
function getTableIdxForTree(data:any, record:any) {
  let idx = -1;
  let _data:any = data;
  if (data && !Array.isArray(data)) {
    _data = Object.values(data)
  }
  let findIdx = false;
  const getTableIdx = (nodes:any) => {
    idx++;
    nodes.forEach((node:any) => {
      if (!findIdx && (node.id && record.id && node.id == record.id) || (node.key && record.key && node.key == record.key)) {
        idx++;
        findIdx = true;
      }
      if (!findIdx && node.children && node.children.length > 0) {
        getTableIdx(node.children);
      }
    });
  };
  getTableIdx(_data);

  return idx;
}

export function getColumnStyleCfg(props: any, column: any, record: any, condValIdx: number, filterCallback?: any) {
  let idx = condValIdx;
  if (props.isTree && props?.allData?.length > 0) {
    idx = getTableIdxForTree(props.allData, record);
  }

  let style: any = {};
  let columnStyleKeys = props?.columnStyleKeys || [];
  if (!column.conditionalStyle) {
    columnStyleKeys.forEach((key: any) => style[key] = column[key]);
  } else {
    let styleByCond: any = _.find(_.values(column.conditionalStyle), (item:any) => {
      if (item.condValue === undefined || item.condValue === null) {
        return false;
      }

      if (_.isArray(item.condValue)) {
        if (_.isBoolean(item.condValue[idx])) {
          return item.condValue[idx];
        } else {
          return item.condValue[idx] == record[column.id];
        }
      }

      let value:any = record[column.id];
      if (column.columnType == ColumnTypes.DATE) {
        if (_.isNumber(value)) {
          let textNum: number = parseInt(value + '', 10);
          let isDate = dayjs(textNum).isValid();
          let text = isDate ? (dayjs(textNum).format(column.dateFormat || "YYYY-MM-DD")) : '';
          return text == item.condValue;
        }
      }

      return item.condValue == record[column.id];

    });

    if (!styleByCond) {
      styleByCond = _.find(_.values(column.conditionalStyle), {value:'default'});
    }

    if (styleByCond && styleByCond.style) {
      style = {...styleByCond.style}
      columnStyleKeys.forEach((key: any) => {
        let styleVal = getEvalValue(style[key]); // TODO: style[key] 值有时计算成功，有时不成功， 这里在执行一次脚本
        if (style.textSize && _.isArray(styleVal)) {
          style[key] = getEvalValue(styleVal[idx]) ;
        }
      })
    }
  }

  return filterCallback ? filterCallback(style, column.columnType) : style;
}

export const getCellNodeWrapper = (style:any = {}, index:number, columnType?:any) => {
  let _divStyle: any = {
    display:'inline-block',
    padding: '4px 10px',
    maxWidth:"100%"
  };

  // 多张图片顺序排列，大于表格宽度换行
  if (columnType == ColumnTypes.IMAGE) {
    _divStyle = {
      display: 'flex',
      flexWrap: 'wrap',
      gap: '6px'
    }
  }

  if (style.textSize) {
    _divStyle.fontSize = `${style.textSize}`;
  }
  if (style.textColor && _.isString(style.textColor) && style.textColor.startsWith('#')) {
    _divStyle.color = `${style.textColor}`;
  }else if(style.textColor && _.isArray(style.textColor)) {
    _divStyle.color = `${style.textColor[index]}`;
  }
  if (style.fontFamily) {
    _divStyle.fontFamily = style.fontFamily;
  }
  if (style.fontStyle) {
    if (style.fontStyle.indexOf('bold') >= 0) {
      _divStyle.fontWeight = 'bold';
    }

    if (style.fontStyle.indexOf('italic') >= 0) {
      _divStyle.fontStyle = 'italic';
    }
  }

  style.textBgColor && (_divStyle.backgroundColor = style.textBgColor);
  style.textBorderColor && (_divStyle.borderColor = style.textBorderColor);
  style.textBorderWidth && (_divStyle.borderWidth = style.textBorderWidth);
  style.textBorderRadius && (_divStyle.borderRadius = style.textBorderRadius);
  style.textBorderBoxShadow && (_divStyle.boxShadow = style.textBorderBoxShadow);

  if (!_divStyle.backgroundColor && !_divStyle.textBorderWidth) {
    _divStyle.padding = "0px";
  }

  if (style.textBorderWidth && !isNaN(style.textBorderWidth)) {
    _divStyle.borderWidth = style.textBorderWidth + 'px';
  }

  let tdAlignStyle: any = {
    display:'flex',
    justifyContent: 'flex-start',
  }
  if (style.horizontalAlignment) {
    if (style.horizontalAlignment == 'left') {
      tdAlignStyle.justifyContent = 'flex-start';
    } else if (style.horizontalAlignment == 'center') {
      tdAlignStyle.justifyContent = 'center';
    } else if (style.horizontalAlignment == 'right') {
      tdAlignStyle.justifyContent = 'flex-end';
    }
  }

  if (style.verticalAlignment) {
    if (style.verticalAlignment == 'top') {
      tdAlignStyle.alignItems = 'flex-start';
    } else if (style.verticalAlignment == 'middle') {
      tdAlignStyle.alignItems = 'center';
    } else if (style.verticalAlignment == 'bottom') {
      tdAlignStyle.alignItems = 'flex-end';
    }
  }

  if(_.isEmpty(style.verticalAlignment)){
    tdAlignStyle.alignItems = 'center';
  }
  _divStyle.width="100%"
  return {
    divStyle: _divStyle,
    tdAlignStyle: tdAlignStyle,
  };
}

export const cellNodeAddIcon = (children:any, btnIcon:any, btnPosition:any, iconColor:any,mainStyle:any = {}) => {
  let iconEle = getIconPark(btnIcon, iconColor);

  let style:any = {};
  if (btnIcon && btnIcon != 'none') {
    if (btnPosition == 'left') {
      style = {marginLeft: "2px"};
    } else if (btnPosition == 'right') {
      style = {marginRight: "2px"};
    }
  }

  let _justifyContent_style:any = {};
  if (mainStyle.horizontalAlignment) {
    if (mainStyle.horizontalAlignment == 'left') {
      _justifyContent_style.justifyContent = 'flex-start';
    } else if (mainStyle.horizontalAlignment == 'center') {
      _justifyContent_style.justifyContent = 'center';
    } else if (mainStyle.horizontalAlignment == 'right') {
      _justifyContent_style.justifyContent = 'flex-end';
    }
  }

  return <div style={{display: 'flex', alignItems:'center',..._justifyContent_style}}>
    {
      (btnIcon && btnIcon != 'none' && btnPosition != 'right') && iconEle
    }
    <div style={{...style}}>{children}</div>
    {
      (btnIcon && btnIcon != 'none' && btnPosition == 'right') && iconEle
    }
  </div>
}

/*
// 表头对齐
horizontalAlignmentColumnHeader // 表头对齐 -- 水平对齐方式

// 文字对齐
horizontalAlignment // 文字对齐 -- 水平对齐方式
verticalAlignment // 文字对齐 -- 垂直对齐方式

// 选择文字样式
fontFamily // 选择文字样式 -- fontFamily

// 文字
textSize // 文字 -- 字体大小
fontStyle // 文字 -- 加粗&斜体
textColor // 文字 -- 文字颜色

// 背景
textBgColor // 背景 -- 文字背景颜色
cellBgColor // 背景 -- 单元格背景颜色

// 按钮样式
btnType // 按钮样式 -- 类型
backgroundBtn // 按钮样式 -- 颜色
fontColor// 按钮样式 -- 文字颜色
borderRadiusBtn // 按钮样式 -- 边框圆角半径
boxShadowBtn // 按钮样式 -- 阴影

// 图片样式
imgSize // 图片样式 -- 尺寸

// 颜色
switchColor // 颜色 -- 开关强调色

// 图标
btnIcon // 图标 -- 选择图标
btnPosition // 图标 -- 位置
iconColor // 图标 -- 图标颜色

// 文字边框&阴影
textBorderWidth // 文字边框&阴影 -- 边框宽度
textBorderColor // 文字边框&阴影 -- 文字边框颜色
textBorderRadius // 文字边框&阴影 -- 边框圆角
textBorderBoxShadow // 文字边框&阴影 -- 阴影
*/

// 表头对齐 文字对齐 选择文字样式 文字 背景 图标 文字边框&阴影  按钮样式 图片样式 颜色
const getStylesByType = (styles:any = {}, type:any = 'none') => {
  let style:any = {};
  styles.horizontalAlignmentColumnHeader && (style.horizontalAlignmentColumnHeader = styles.horizontalAlignmentColumnHeader);

  switch (type) {
    case ColumnTypes.TEXT: // 表头对齐 文字对齐 选择文字样式 文字 背景 图标 文字边框&阴影
    case ColumnTypes.NUMBER:
    case ColumnTypes.LINK:
    case ColumnTypes.DATE:
      style = _.cloneDeep(styles);
      // 按钮样式
      delete style.btnType;
      delete style.backgroundBtn;
      delete style.fontColor;
      delete style.borderRadiusBtn;
      delete style.boxShadowBtn;
      // 图片样式
      delete style.imgSize;
      // 颜色
      delete style.switchColor;
      break;
    case ColumnTypes.SELECT:
      break;
    case ColumnTypes.BOOL:
      break;
    case ColumnTypes.BUTTON:
      style.btnType = styles.btnType;
      style.backgroundBtn = styles.backgroundBtn;
      style.borderRadiusBtn = styles.borderRadiusBtn;
      style.boxShadowBtn = styles.boxShadowBtn;
      style.btnIcon = styles.btnIcon;
      style.btnPosition = styles.btnPosition;
      style.iconColor = styles.iconColor;
      break;
    case ColumnTypes.IMAGE:
      style.imgSize = styles.imgSize;
      break;
    case ColumnTypes.RICH:
    case ColumnTypes.FILE:
    case ColumnTypes.VIDEO:
      break;
    case ColumnTypes.SWITCH:
      style.horizontalAlignment = styles.horizontalAlignment;
      style.verticalAlignment = styles.verticalAlignment;
      style.switchColor = styles.switchColor;
      break;
  }

  return style;
}

function AntdTable(props: any) {
  const {
    onToggleDrag,
    updateWidgetProperty,
    allData: tableData,
    tableColumns,
    columnWidthMap,
    height,
    isShowNo,
    isActionVisible,
    isActionFixed,
    tableAction,
    isActionCollapse,
    tableActionNo,
    actionCollapseIconColor,
    selectType,
    isPagination,
    isRowSelection,
    pageSizeOptions,
    onCellClick,
    onRowSelection,
    paginationChange,
    textSizeBody,
    textSizeHead,
    textColorHead,
    textColorBody,
    horizontalAlignmentBody,
    horizontalAlignmentHead,
    verticalAlignmentBody,
    verticalAlignmentHead,
    fontStyleHead,
    fontStyleBody,
    backgroundHead,
    isZebraStripe,
    backgroundBody1,
    backgroundBody2,
    backgroundMouseOver,
    currPage,
    pageSize,
    total,
    variant,
    borderRadius,
    borderColor,
    borderWidth,
    boxShadow,
    fixTableColumns,
    compactMode,
    isDirty,
    primaryColorTheme,
    selectedIndex,
    isTree,
    defaultSelectedKeys,
    isRowSelectionDisabledExpr
  } = props;
  const reCellNode = (columnType: any, text: any, column: any, record: any, idx:number) => {
    if (_.isNil(text) && columnType != ColumnTypes.BUTTON && _.isEmpty(column.columnReg)) {
      return null;
    }
    let res: any = null;
    let style = getColumnStyleCfg(props, column, record, idx, getStylesByType);
    if (columnType == ColumnTypes.BUTTON) {
      return reItems(props, column, record, 0);
    } else if (columnType == ColumnTypes.SWITCH) {
      return <SwitchWrapper disabled={true} color={style.switchColor || primaryColorTheme} checked={text}/>
    } else if (columnType == ColumnTypes.DATE) {
      if (_.isString(text)) {
        if (text.includes('~')) {//日期区间
          let dateArr = text.split('~');
          let date1 = dateArr[0],
            date2 = dateArr[1],
            date1Num = parseInt(date1, 10),
            date2Num = parseInt(date2, 10);
          let isDate = dayjs(date1Num).isValid() && dayjs(date2Num).isValid();
          if (isDate) {
            let date1Str = dayjs(date1Num).format(column.dateFormat || "YYYY-MM-DD");
            let date2Str = dayjs(date2Num).format(column.dateFormat || "YYYY-MM-DD");
            res = `${date1Str}~${date2Str}`;
          } else {
            res = <>{text}</>;
          }
        } else {
          let textNum: number = parseInt(text, 10);
          let isDate = dayjs(textNum).isValid();
          res = <>{isDate ? (dayjs(textNum).format(column.dateFormat || "YYYY-MM-DD")) : text}</>
        }
      } else if (_.isNumber(text)) {
        let isDate = dayjs(text).isValid();
        res = <>{isDate ? (dayjs(text).format(column.dateFormat || "YYYY-MM-DD")) : text}</>
      } else {
        res = <>{text}</>
      }

      if (typeof res === "object") {
        res = res.props.children || '';
      }
      let node = <div dangerouslySetInnerHTML={{
        __html: column.columnReg&&column.columnReg.replace?
          column.columnReg.replace('$data', res):
          res
      }}/>;

      if (style.btnIcon) {
        node = cellNodeAddIcon(node, style.btnIcon, style.btnPosition, style.iconColor,style);
      }

      return node;

    } else if (columnType == ColumnTypes.IMAGE || columnType == ColumnTypes.FILE) {
      if (_.isEmpty(text) || text == '[]') {
        return null;
      }

      let files: any;
      if (isValidJSON(text) && text.startsWith('[{')) {
        files = JSON.parse(text);
      } else if(_.isString(text)) {
        // 7103 【SIT】服务返回给table列多张图片时，在table上显示为裂开了
        files = [];
        text.split(',').forEach(imagCode => {
          imagCode && files.push({
            url: isURL(imagCode) ? imagCode : `${apiPath}/${getTenant()}/file/${imagCode}`
          });
        });
      }

      if (files?.length > 0) {
        if (columnType == ColumnTypes.IMAGE) {
          let size = parseInt(column.imgSize);
          if (isNaN(size)) {
            size = column.imgSize == 'XL' ? 80 : column.imgSize == 'ML' ? 60 : 40;
          }

          return <Image.PreviewGroup>
            {
              files.map((item: any, index: number) => (
                <Image key={index} width={size} height={size} src={item.url? item.url: fileCodeToPath(item.code)}/>
              ))
            }
          </Image.PreviewGroup>;
        } else {
          let _textObj:any = files[0];
          return <>{_textObj ? <a href={_textObj.url} target={'_blank'}>{_textObj[0]?.filename}</a> : null}</>
        }
      }

    } else if (columnType == ColumnTypes.VIDEO) {
      if (isValidJSON(text)) {
        let isJsonStr = text.startsWith('[{') && text.endsWith('}]');
        let _textObj: any;
        if (isJsonStr) {
          _textObj = JSON.parse(text)?.[0];
        }
        return <>{_textObj ? <video src={_textObj.url} controls={true}/> : null}</>
      }
    } else if (columnType == ColumnTypes.RICH) {
      return <div style={{maxWidth:"100%"}} dangerouslySetInnerHTML={{__html: text}}/>
    } else {
      style.maxWidth="100%";
      if (style.textColor) {
        style.color = style.textColor;
      }
      if (columnType == ColumnTypes.LINK) {
        style.cursor = 'pointer';
      }

      let _fontStyle = style.fontStyle;
      style.fontStyle = '';
      if (_fontStyle?.indexOf('italic') >= 0) {
        style.fontStyle = 'italic';
      }

      if (_fontStyle?.indexOf('bold') >= 0) {
        style.fontWeight = 'bold';
      }

      if (style.textSize) {
        style.fontSize = style.textSize;
      }
      if(text==undefined){
        text="";
      }
      if (columnType == ColumnTypes.NUMBER) {
        text=formatNumber(text,column.decimal);
       }
      let node = <span style={style}>{text}</span>
      //如果是js计算值
      if (_.isArray(column.columnReg)
        && !_.isEmpty(column.columnReg)
        && _.isString(column.columnReg[idx])
      ) {
        let text_reg = column.columnReg[idx];
        node = <div className='byk-tb-cell-text' style={style} dangerouslySetInnerHTML={{__html: text_reg.replace('$data', text)}}/>
      } else if (_.isString(column.columnReg) && !_.isEmpty(column.columnReg)) {
        node = <div  className='byk-tb-cell-text' style={style} dangerouslySetInnerHTML={{__html: column.columnReg.replace('$data', text)}}/>;
      }

      if (style.btnIcon && columnType !== ColumnTypes.BUTTON) {
        node = cellNodeAddIcon(node, style.btnIcon, style.btnPosition, style.iconColor,style);
      }

      return node;
    }
  }

  //列处理
  let columnsValues = _.sortBy(Object.values(tableColumns), ['index']).filter((i: any) => {
    // 7101 【SIT】权限设置中，给table的某一列（如下图给设备类型）取消勾选，预览时，table中依然有设备类型列
    // 7100 【SIT】权限设置中，给table的“编辑”按钮或者整个操作列都取消勾选，保存后预览时，table中依然显示了“编辑”按钮
    let isVis =  i.isCellVisible != false;
    if (props.widgetVisible) {
      isVis = isVis && props.widgetVisible.includes(`${props.widgetId}_COLUMNS_${i.id}`);
    }
    return isVis;
  });
  let fixedLeft = _.filter(columnsValues, (i: any) => {
    return i.isFixed && (i.sticky == 'left'||!i.sticky);
  });
  let fixedRight = _.filter(columnsValues, (i: any) => {
    return i.isFixed && i.sticky == 'right';
  });
  let fixedNo = _.filter(columnsValues, (i: any) => {
    return !i.isFixed;
  });
  const reColumnsFun = (columns: any) => {
    return columns.map((i: any) => {
      let thAlign = i.horizontalAlignmentColumnHeader || horizontalAlignmentHead;
      if (thAlign == 'center') {
        thAlign = 'thAlignCenter';
      } else if (thAlign == 'right') {
        thAlign = 'thAlignRight';
      } else {
        thAlign = 'thAlignLeft';
      }

      let _column: any = {
        ...i,
        title: i.label,
        dataIndex: i.id,
        className: `tableDataCell ${thAlign}`,
        width: columnWidthMap?.[i.id] || 150,
        key: i.key || i.id || i.label,
      };
      if (i.isSort) {
        _column.sorter = (a: any, b: any) => {
          if (a[i.id] && !b[i.id]) {
            return -1;
          }
          if (!a[i.id] && b[i.id]) {
            return 1;
          }
          if (!a[i.id] && !b[i.id]) {
            return 0;
          }
          return (a[i.id] + '').localeCompare(b[i.id]);
        }
      }
      if (i.isEllipsis) {
        _column.ellipsis = {
          showTitle: false
        }
      }
      if (i.isFixed) {
        _column.fixed = !i.sticky?"left":i.sticky;
      }

      return {
        ..._column,
        onCell: (record:any, rowIndex:any) => {
          let style = getColumnStyleCfg(props, i, record, rowIndex, getStylesByType);
          let _cellStyle:any = {};
          if (style.cellBgColor) {
            _cellStyle.backgroundColor = style.cellBgColor;
          } else if (i.backgroundCell) {
            _cellStyle.backgroundColor = style.backgroundCell;
          }
          return {
            style: _cellStyle
          };
        },
        render: (text: any, record: any, index: any) => {
          /*样式配置 begin*/
          let style = getColumnStyleCfg(props, i, record, index, getStylesByType);
          let {divStyle, tdAlignStyle} = getCellNodeWrapper(style, index, i.columnType);
          /*样式配置 end*/
          let _node = reCellNode(i.columnType, text, i, record, index);
          return (
            <div style={tdAlignStyle}>
              <div style={divStyle} onClick={() => {
                i.onClick && onCellClick(record, i.onClick)
              }}>
                {i.isEllipsis ? (
                  <Tooltip placement="topLeft" title={text}>
                    {_node}
                  </Tooltip>
                ) : (_node)}
              </div>
            </div>
          )
        }
      }
    })
  }
  let tableColumnsHandle: any = [
    ...reColumnsFun(fixedLeft),
    ...reColumnsFun(fixedNo),
    ...reColumnsFun(fixedRight)
  ];
  //是否显示序号
  if (isShowNo) {
    tableColumnsHandle.unshift({
      title: fixTableColumns?.['_xh']?.label || '序号',
      label: fixTableColumns?.['_xh']?.label || '序号',
      id: '_xh',
      className: 'tableDataCellXh',
      width: columnWidthMap?.['_xh'] || 80,
      fixed: fixedLeft.length == 0 ? false : 'left',
      render: (text: any, record: any, index: any) => {
        return <>{index + 1}</>
      }
    })
  }

  if (isActionVisible) {
    tableColumnsHandle.push({
      title: fixTableColumns?.['_cz']?.label || '操作',
      label: fixTableColumns?.['_cz']?.label || '操作',
      id: '_cz',
      width: columnWidthMap?.['_cz'] || 200,
      fixed: (fixedRight.length > 0 || isActionFixed) ? 'right' : false,
      render: (text: any, record: any, index: any) => {
        let items = Object.values(_.sortBy(tableAction, 'index')).filter((i:any)=>{
          return i.isCellVisible;
        });
        let no = parseInt(tableActionNo, 10);
        if (isActionCollapse && _.isNumber(no) && no < items.length && no >= 0) {
          let items1 = items.slice(0, no);
          let items2 = items.slice(no);
          let items1Temp = items1.map((i: any) => {
            return reItems(props, i, record, index);
          });
          const dropdownItems = items2.filter((i:any)=>{
            return reIsVisible(props, i.isCellVisible, index);
          }).map((i: any) => {
            return {
              key: `${i.index}`,
              disabled: i.isCellDisable,
              label: (
                <a rel="noopener noreferrer" onClick={()=>{
                  i.onClick && onCellClick(record, i.onClick);
                }}>
                  {i.label}
                </a>
              )
            }
          });

          let items2Temp = (
            <ActionMenu items={dropdownItems}>
              <StyledButton
                buttonColor={actionCollapseIconColor}
                iconName={"MoreOne"}
                dimension={32}
              />
            </ActionMenu>
          );
          return (
            <>
              {items1Temp}{items2Temp}
            </>
          )
        } else {
          return items.map((i: any) => {
            return reItems(props, i, record, index);
          })
        }
      }
    })
  }

  const rowSelection = {
    selectedRowKeys: selectedIndex,
    onChange: (selectedRowKeys: number[], selectedRows: any) => {
      onRowSelection(selectedRowKeys, selectedRows);
    },
    getCheckboxProps: (record: any) => {
      return { disabled: record.isRowSelectionDisabled };
    },
  };

  let _pageSize = pageSize;
  if (!isDirty){
    _pageSize = 10;
    if (pageSizeOptions && pageSizeOptions.split.length > 0) {
      _pageSize = pageSizeOptions.split(',')[0] ;
    }
  }
  const reDefaultKeys = (str:string)=>{
    if(!str){
      return null;
    }else if(str.startsWith&&str.startsWith('[')) {
      return JSON.parse(str);
    }else if(str.split&&str.indexOf(',')){
      return str.split(',');
    }
    return str;
  }
  useEffect(()=>{
    let default_Keys = reDefaultKeys(defaultSelectedKeys);
    let select_index = [], select_rows = [];
    if(default_Keys){
      select_index = default_Keys;
      select_rows = tableData.filter((i:any)=>{
        return default_Keys.includes(i.id);
      })
    }
    if(isRowSelection&&!_.isEqual(default_Keys, selectedIndex)){
      onRowSelection(select_index, select_rows);
    }
  }, [tableData]);

  const tableDataHandle = (data: any) => {
    if(isRowSelection&&isRowSelectionDisabledExpr){
      try{
        return data.map((i:any, idx:number)=>{
          return {
            ...i,
            isRowSelectionDisabled: isRowSelectionDisabledExpr[idx]
          }
        })
      }catch{
        return [];
      }
    }else{
      return data??[];
    }
  }


  return <StyledTable
    isTree={isTree}
    onToggleDrag={onToggleDrag}
    columns={tableColumnsHandle}
    dataSource={tableDataHandle(tableData)}
    bordered={variant === 'DEFAULT' || !variant}
    updateWidgetProperty={updateWidgetProperty}
    scroll={{x: 800, y: height + (isPagination ? -100 : - 50)}}

    variant={variant}
    size={compactMode}
    rowKey={(record:any) => record?.id || record?.key}
    rowSelection={isRowSelection && {
      type: selectType,
      ...rowSelection,
    }}
    pagination={(isPagination && !isTree) ? {
      current: currPage,
      pageSize: _pageSize,
      total: (tableData && total < tableData.length) ? tableData.length : total,
      showTotal: (total: number) => `总共${total}项`,
      showSizeChanger: true,
      pageSizeOptions: pageSizeOptions.split(','),
      onChange: (page: any, pageSize: any) => {
        paginationChange(page, pageSize);
      }
    } : false}
    height={height}
    boxShadow={boxShadow}
    borderWidth={borderWidth}
    borderColor={borderColor}
    borderRadius={borderRadius}
    primaryColorTheme={primaryColorTheme}
    textSizeBody={textSizeBody}
    textSizeHead={textSizeHead}
    horizontalAlignmentBody={horizontalAlignmentBody}
    horizontalAlignmentHead={horizontalAlignmentHead}
    verticalAlignmentBody={verticalAlignmentBody}
    verticalAlignmentHead={verticalAlignmentHead}
    fontStyleHead={fontStyleHead}
    fontStyleBody={fontStyleBody}
    textColorHead={textColorHead}
    textColorBody={textColorBody}
    backgroundHead={backgroundHead}
    isZebraStripe={isZebraStripe}
    backgroundBody1={backgroundBody1}
    backgroundBody2={backgroundBody2}
    backgroundMouseOver={backgroundMouseOver}
  />
}

export default AntdTable;
